<style>
.test .dropdown-menu {
  transform: translate3d(-4cm, 1cm, -6px) !important;
  left: -45px !important;
}

tbody td {
  font-size: 13px !important;
}

thead th {
  font-size: 13px !important;
}

.badge-yellow {
  background-color: yellow;
}

@media (max-width: 647px) {
  .res {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 506px) {
  .resButtons {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .resLead {
    width: 100%;
  }
}

@media (max-width: 400px) {
  .resLines {
    width: 100%;
    float: right;
    display: flex;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .resButton {
    margin-top: 2px;
  }
}

/* .vs__clear {
  display: none;
} */

/* td ul {
  transform: translate3d(-94px, 19px, 0px) !important;
} */

.example::-webkit-scrollbar {
  display: none !important;
}
</style>
<template>
  <div v-if="renderComponent">
    <b-card-code :Addbutton="true" :routerpath="routerpath" :formOptions="formOptions" :visible="visible"
      :selectedID="selectedID" :assignToFormOptions="assignToFormOptions" :getGridData="getGridData">
      <!-- input search -->

      <!-- <div class=" d-flex justify-content-between"> -->
      <!-- <div class="d-flex align-items-center"> -->
      <!-- <b-form-checkbox v-model="isFilterSwitch" checked="false" @change="clickSwitch" name="check-button" switch
            inline />
          <b-form-group>
            <label class="mr-1">Column Filter</label>
            <v-select v-model="columnFilter" style="min-width: 4cm; max-width: 10cm;"
              :disabled="isFilterSwitch ? disabled : ''" @input="isFilterColumn"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" multiple label="field" :options="columnsData" />
          </b-form-group> -->
      <!-- </div> -->
      <div>
        <b-row>
          <b-col md="6">
            <div>
              <b-row>
                <!-- <b-col md="2">
                  <label class="h4 d-flex align-items-center pr-2" style="font-weight: 500 !important">{{
                    title
                  }}</label>
                </b-col> --->
                <!-- <b-col md="10">
                  <div v-if="title == 'Project'">
                    <b-row>
                      <b-col class="p-0" md="4">
                        <b-form-group>
                          <div class="d-flex align-items-center">
                            <label class="mr-1">State</label>
                            <v-select class="d-inline-block mr-2" style="width: 10rem" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              " :options="stateOptions" placeholder="None" label="State"
                              @input="advanceSearch($event.State, 'state')" />
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <b-form-group>
                          <div class="d-flex align-items-center">
                            <label class="mr-1">City</label>
                            <v-select class="d-inline-block mr-2" style="width: 10rem" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              " :options="CityOption" placeholder="None" label="City"
                              @input="advanceSearch($event.City, 'city')" />
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col class="p-0" md="4">
                        <b-form-group>
                          <b-button @click="clearFilter" variant="success" size="sm">
                            <feather-icon icon="PlusIcon" class="mr-50" />
                            <span class="align-middle">Clear Filters</span>
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-if="title == 'Plot'">
                    <b-row>
                      <b-col class="p-0" md="12">
                        <b-form-group>
                          <div class="d-flex align-items-center">
                            <label class="mr-1">Project</label>
                            <v-select class="d-inline-block mr-2" style="width: 10rem" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              " :options="projectOptions" placeholder="None" label="name"
                              @input="advanceSearch($event, 'project')" />
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-col> -->
              </b-row>
            </div>
          </b-col>
          <b-col md="12" v-if="title !== 'Legal'">
            <div class="custom-search d-flex justify-content-end">
              <b-row>
                <b-form-group :class="plot == true || lead == true || tour == true
                  ? 'resLead'
                  : 'resButtons'
                  ">
                  <div class="d-flex align-items-center">
                    <label class="mr-1">Search</label>
                    <b-form-input @input="advanceGlobleSearch" placeholder="Search" type="text" class="d-inline-block" />
                  </div>
                </b-form-group>

                <b-form-group :class="plot == true || lead == true || tour == true
                  ? 'resLead'
                  : 'resButtons'
                  ">
                  <div class="d-flex align-items-center flex-wrap res w-100 justify-content-end">
                    <b-button v-if="multiplepath" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickAddMultiple">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add Multiple</span>
                    </b-button>

                    <b-button v-if="plot" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="lead" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="lead" variant="success" size="sm" class="ml-2 resButton" @click="handleClickLead">
                      <div style="display: none">
                        <b-form-file id="fileUploadLead" v-model="leadSheetImport" v-if="lead" @input="handleFileChangeLead($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import Lead</span>
                    </b-button>

                    <b-button v-if="lead" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickTransferLead">
                      <span class="align-middle">Transfer Lead</span>
                    </b-button>
                    <b-button v-if="title == 'sales'" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickTransferLead">
                      <span class="align-middle">Transfer Lead</span>
                    </b-button>
                    <b-button v-if="tour" variant="secondary" size="sm" class="ml-2 resButton"
                      @click="handleClickAddTour">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add Tour</span>
                    </b-button>
                    <b-button v-if="plot" variant="success" size="sm" class="ml-2 resButton" @click="handleClickPlot">
                      <div style="display: none">
                        <b-form-file id="fileUpload" v-if="plot" @input="handleFileChange($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import Plot</span>
                    </b-button>
                    <b-button v-if="kyc !== true" variant="primary" size="sm" class="ml-2 resButton" @click="handleClickAddbutton">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add New</span>
                    </b-button>

                    <b-button v-if="bulksales == true
                      " variant="success" size="sm" class="ml-2 resButton" @click="handleClickBulkSales">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Bulk Add</span>
                    </b-button>

                    <!-- <b-button v-if="approval == true" variant="primary" size="sm" class="ml-2 resButton"
                      @click="handleClickApproval">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add New</span>
                    </b-button>

                    <b-button v-if="reminder == true || template == true" variant="primary" size="sm"
                      class="ml-2 resButton" @click="handleClickReminder">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add New</span>
                    </b-button> -->
                    <b-button v-if="title == 'Daily Working'" variant="success" size="sm"
                      class="ml-2 resButton" @click="$router.push('/reports/hr/workingreport')">
                      <span class="align-middle">Working Report</span>
                    </b-button>
                    <b-button variant="danger" size="sm" class="ml-1 resButton" @click="handleMultiDelete"
                      v-if="(canDelete == 1 || userRole == 'admin') && title!== 'Legal' && title!== 'Issue Log' && title!== 'Modules'&&  title!== 'Softwares'">
                      <!-- <span class="align-middle h5 pr-1 text-white">Delete</span> -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash3-fill" viewBox="0 0 16 16">
                        <path
                          d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                      </svg>
                    </b-button>

                    <span class="ml-2 test resLines">
                      <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                        <template v-slot:button-content>
                          <feather-icon width="30" height="30" icon="AlignRightIcon" size="16"
                            class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item @click="downloadExcel('All')" variant="warning" v-if="sheetApi">
                          <b>
                              <feather-icon icon="ArrowDownIcon" class="mr-50" />
                                Download All Data
                          </b>
                        </b-dropdown-item>
                        <b-dropdown-item @click="downloadExcel('')" variant="warning" >
                          <b>
                            <feather-icon icon="ArrowDownIcon" class="mr-50" />
                              Download This Page Data
                          </b>
                        </b-dropdown-item>
                        <div class="example" style="
                            width: 6cm;
                            height: 7cm;
                            overflow: hidden scroll;
                            padding: 6px 20px;
                          ">
                          <b-form-group>
                            <!-- <b-button variant="success" size="sm" class="ml-2 resButton" @click="DownloadExcel">
                              <feather-icon icon="ArrowDownIcon" class="mr-50" />
                              <span class="align-middle">Download Excel</span>
                            </b-button> -->
                            <label class="h5"> Select Field </label>
                            <b-form-checkbox-group id="checkbox-group-1" v-model="columnFilter" @input="isFilterColumn"
                              :options="columnsData" name="field" class="demo-inline-spacing" />
                          </b-form-group>
                        </div>
                      </b-dropdown>
                    </span>
                    <!-- <b-button  variant="primary" size="sm" class="ml-2 resButton"
              @click="printData">    transform: translate3d(-4cm, 1cm, -6px);
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">print</span>
            </b-button> -->
                    <b-modal id="modal-form" v-model="visible" size="sm" cancel-variant="outline-secondary"
                      ok-title="Submit" cancel-title="Close" :title="showPassword
                        ? 'Change password'
                        : selectedID
                          ? formOptions.formTitle.replace('Add', 'Edit')
                          : formOptions.formTitle
                        " no-close-on-backdrop hide-footer>
                      <Form :popUp="true" :options="formOptions" :handleCloseModel="handleCloseModel"
                        :selectedID="selectedID" :getGridData="getGridData" :edit="edit" :add="add"></Form>
                    </b-modal>
                    <!-- <b-modal id="modal-form" v-model="approvalPopUp" title="Approval" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <approvalStatic :closepopup="closepopup" :getGridData="getGridData" :selectedID="selectedID" />
                    </b-modal> -->

                    <b-modal id="modal-form" v-model="staticPopUp" :title="title" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <component :is="popUpCompnent" :closepopup="closepopup" :getGridData="getGridData" :selectedID="selectedID"/>
                    </b-modal>
<!--
                    <b-modal id="modal-form" v-model="reminderPopUp" title="Reminder" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <reminderStatic :closepopup="closepopup" :getGridData="getGridData" :selectedID="selectedID" />
                    </b-modal>

                    <b-modal id="modal-form" v-model="salesdeedPopup" title="Sales Deed" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <sales-deed :salesDeedClose="closepopup" :selectedId="selectedID" :getGridData="getGridData"
                        :selectedPlot='selectedPlot' />
                    </b-modal>
                    <b-modal id="modal-form" v-model="templatePopUp" title="Template" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <addTemplate :closepopup="closepopup" :getGridData="getGridData" :selectedID="selectedID" />
                    </b-modal> -->

                    <b-modal id="modal-form" v-model="transferClick" title="Transfer Lead" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <TransferLead :closepopup="closepopup" />
                    </b-modal>

                    <b-modal id="modal-form-view" v-model="viewPopUp" :title='title' size="lg"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <component :is="viewComponent" :closepopup="closepopup" :selectedID='selectedID' v-if="viewComponent"/>
                      <viewPage v-else :closepopup="closepopup" :moduleapi='moduleapi' :title="title" :viewFields="viewFields"
                        :getEditValue="formOptions.getEditValue" :selectedID='selectedID' />
                    </b-modal>
                  </div>
                </b-form-group>
              </b-row>
            </div>
          </b-col>
          <!-- <b-col md="12" v-else>

            <div class="custom-search d-flex justify-content-end mb-1">
              <b-button variant="success" size="sm" class="ml-2 resButton" @click="handleMultiMessage"
                v-if="title == 'Lead'">
                <span class="align-middle h5 pr-1 text-white">Whatsapp</span>
                <svg xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px" fill="white"
                  class="bi bi-whatsapp" viewBox="0 0 16 16">
                  <path
                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                </svg>
              </b-button>
              <b-button variant="danger" size="sm" class="ml-2 resButton" @click="handleMultiDelete"
                v-if="(canDelete == 1 || userRole == 'admin')">
                <span class="align-middle h5 pr-1 text-white">Delete</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-trash3-fill" viewBox="0 0 16 16">
                  <path
                    d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                </svg>
              </b-button>
            </div>
          </b-col> -->
        </b-row>
      </div>
      <!-- </div> -->

      <!-- table -->
      <vue-good-table class="table" :columns="columnsItem" :rows="rows" :rtl="direction" @on-row-dblclick="handleEdit"
        :isLoading="loadData" :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: false,
          selectAllByGroup: false,

        }" @on-selected-rows-change="selectionChanged($event)" :line-numbers="true" :search-options="{
          externalQuery: searchTerm,
        }" :pagination-options="pagination">
        <!-- <div slot="table-actions">
        This will show up on the top right of the table.
      </div> -->
        <template slot="column-filter" slot-scope="props">
          <v-select :options="data[props.column.url]"
              v-if="props.column.url!=='getUsers' && props.column.type && (props.column.type == 'dropdown' || props.column.type == 'staticdropdown')"
              :label="props.column.responseValue" multiple
              @input="(valuesArray) => handleCustomFilter(valuesArray, props.column.field, 'dropdown',props.column.searchField)" />

              <v-select :options="data[props.column.url]"
              v-else-if="props.column.url=='getUsers' "
              style="min-width:180px"
              :label="props.column.responseValue" multiple
              @input="(valuesArray) => handleCustomFilter(valuesArray, props.column.field, 'dropdown',props.column.searchField)" >
                <template #option="{ name, profile_image, username, surname }">
                  <b-avatar :src="getprofileImage(profile_image)" v-if="name !== 'All'" />
                  <span class="font-weight-bolder"> {{ name }} {{surname}}</span
                  ><span v-if="name !== 'All'">({{ username }})</span>
                </template>
          </v-select>

          <b-form-input v-else @input="handleCustomFilter($event, props.column.field, 'textbox',props.column.searchField)" placeholder="Search"
            type="text" class="d-inline-block" />

          </template>
          <template slot="loadingContent">
            <b-spinner variant="primary" label="Text Centered" />
          </template>
          <template slot="table-row" slot-scope="props">
          <div>
          </div>

          <div v-if="props.column.field === 'image'" class="text-nowrap">
            <b-image :src="props.row.attachment" class="mx-2" size="45px" />
            <!-- <span class="text-nowrap">{{ props.row.fullName }}</span> -->
          </div>
          <!-- <span v-else-if="props.column.type == 'dropdown'||props.column.type == 'staticdropdown'" class="text-nowrap">
            {{ props.row[props.column.field][props.column.responseValue] }}
           </span> -->
          <!-- <span v-else-if="props.column.field === 'leadcategory_id'">
            {{ props.row.leadcategory_id ? props.row.leadcategory_id.length > 0 ? props.row.leadcategory_id[0].name : '' :
              '' }}
          </span> -->

          <div class="w-full" style="text-align: center" v-else-if="props.column.field == 'active' && props.row.projectstatus
            ">
            <b-form-checkbox v-model="enabledisable[props.row.id]" @input="handelClickEnableDisable(props.row.id)"
              class="custom-control-primary" name="check-button" switch>
            </b-form-checkbox>
          </div>
          <!-- <span v-else-if="props.column.field === 'PlotData'">
            {{ props.row.PlotData.length }}
          </span> -->

          <!-- <span v-else-if="props.column.field === 'assignto' && (title == 'Lead' || title == 'Memo')">
            {{ props.row.assignto.length > 0 ? props.row.assignto[0].name : '' }}
          </span>
          <span v-else-if="props.column.field === 'employee' && (title == 'Daily Working')">
            {{ props.row.employee ? props.row.employee.name : '' }}
          </span> -->
          <!-- <span v-else-if="props.column.field === 'employee_id' && (title == 'Leaves')">
            {{ props.row.employee_data ? props.row.employee_data.name : '' }}
          </span> -->
          <!-- <span
            v-else-if="props.column.field === 'name' && (title == 'Channel Partner' || title == 'Frenchise' || title == 'Employee' || title == 'Customer' || title == 'Driver')">
            {{ (props.row.name ? props.row.name : '') + ' ' + (props.row.surname ? props.row.surname : '') }}
          </span> -->
          <!-- <span v-else-if="props.column.field === 'project' ">
            <span v-if="Array.isArray(props.row.project)">
              {{ props.row.project.length > 0 ? props.row.project[0].projectname : '' }}
            </span>
            <span v-else>
              {{ props.row.project ? props.row.project.projectname : '' }}
            </span>
          </span>
          <span v-else-if="props.column.field === 'leadsource'">
            {{ props.row.leadsource.length > 0 ? props.row.leadsource[0].name : '' }}
          </span>
          <span v-else-if=" props.column.field === 'team'">
             <span v-if="Array.isArray(props.row.team_data)">
              {{ props.row.team_data.length > 0 ? props.row.team_data[0].name : '' }}
            </span>
            <span v-else>
              {{ props.row.team_data ? props.row.team_data.name : '' }}
            </span>
          </span>
          <span v-else-if="props.column.field === 'parent'">
            {{ props.row.parent &&  props.row.parent.name? props.row.parent.name : props.row.parent }}
          </span> -->
            <span v-else-if="props.column.field === 'plotsize'">
              {{ props.row.plotno.length>0 ?
                 (props.row.plotno[0].plotareayd) : '' }}
            </span>
            <span v-else-if="props.column.field === 'plotrate'">
                     {{ props.row.plotno.length > 0 ?
                    (props.row.team_data[0].role == 'franchise' ? props.row.plotno[0].franchiserate : props.row.plotno[0].rateperyd )
                    : '' }}
            </span>
            <span v-else-if="props.column.field === 'plotvalue'">
                  {{ props.row.plotno.length > 0 ?
                    (props.row.team_data[0].role == 'franchise' ? props.row.plotno[0].plotValueFr : props.row.plotno[0].plotValue )
                    : '' }}
            </span>
            <span v-else-if="props.column.field === 'receivedamount'">
                  {{ props.row.plotno.length > 0 ? (parseFloat(props.row.totalpayment? props.row.totalpayment: 0 ) - parseFloat(props.row.remainingpayment?props.row.remainingpayment:0)).toFixed(2) : '' }}
            </span>
            <span v-else-if="props.column.field === 'duedate' &&  title === 'Sales'">

                  {{ props.row.paymenttermday ? moment(props.row.bookingdate,'DD/MM/YYYY').add(parseFloat(props.row.paymenttermday),'days').format('DD/MM/YYYY'): '' }}
            </span>

          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'status' && !changeStatus[props.row.id]" class="cursor-pointer"
            @click="clickStatusChage(props.row, title)">
            <b-badge :variant="statusVariant(props.row.status)">
              {{ props.row.status }}
            </b-badge>
          </span>
           <span v-else-if="props.column.field === 'customer' && title == 'Plot'" class="cursor-pointer">
              <div v-if="props.row.sales_data && props.row.sales_data.customer">
                {{ props.row.sales_data.customer.name }} {{ props.row.sales_data.customer.surname }}
              </div>
            </span>
          <div v-else-if="props.column.field === 'status' && title == 'Plot' && changeStatus[props.row.id]">
            <v-select v-model="props.row.status" label="name" style="width:120px"
              :options="['Vacant', 'Booked', 'Sold', 'Hold', 'Registered']"
              @input="handleStatusChage(props.row.status, props.row.id)" />
          </div>
          <span v-else-if="title === 'Site Visit' && props.column.field == 'lock'">
            <b-badge :variant="statusVariant(props.row.lock == 0 ? 'Accepted' : 'Pending')
              ">
              {{ props.row.lock == 0 ? "Accepted" : "pending" }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'projectstatus'">
            <b-badge :variant="statusVariant(props.row.projectstatus)">
              {{ props.row.projectstatus }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'approved1'">
            <b-badge :variant="statusVariant(props.row.approved1)">
              {{ props.row.approved1 }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field == 'is_kyc'">
            <b-badge :variant="statusVariant(
              props.row.is_kyc == 0
                ? 'Pending'
                : props.row.is_kyc == 1
                  ? 'Accepted'
                  : 'Rejected'
            )
              ">
              {{
                props.row.is_kyc == 0
                ? "Pending"
                : props.row.is_kyc == 1
                  ? "Accepted"
                  : "Rejected"
              }}
            </b-badge>
          </span>
          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'" style="width: fit-content; display: flex">
            <b-badge v-if="userRole == 'admin' &&
              ((title == 'Receipt' && props.row.approved1 == 'Pending') ||
                title == 'KYC')
              " variant="primary" :id="'recieptApprove' + props.row.id" class="mr-50 cursor-pointer"
              @click="approveReceipt(props.row, 'Approved', title)">
              <feather-icon icon="CheckIcon" />
            </b-badge>
            <b-tooltip
            v-if="userRole == 'admin' &&
              ((title == 'Receipt' && props.row.approved1 == 'Pending') ||
                title == 'KYC')
              "
            :target="'recieptApprove' + props.row.id" triggers="hover">
              Approve
            </b-tooltip>
            <b-badge v-if="userRole == 'admin' &&
              ((title == 'Receipt' && props.row.approved1 == 'Pending') ||
                title == 'KYC')
              " variant="danger" :id="'recieptReject' + props.row.id" class="mr-50 cursor-pointer"
              @click="approveReceipt(props.row, 'Rejected', title)">
              <feather-icon icon="XIcon" />
            </b-badge>

            <b-tooltip
            v-if="userRole == 'admin' &&
              ((title == 'Receipt' && props.row.approved1 == 'Pending') ||
                title == 'KYC')
              " variant="danger"
            :target="'recieptReject' + props.row.id" triggers="hover">
              Reject
            </b-tooltip>
            <b-badge :id="'download' + props.row.id" v-if="title == 'Receipt' && props.row.approved1 == 'Approved' && props.row.transactiontype!=='Other'"
              @click='handelRecieptPDF(props.row.id)' variant="success" class="mr-50 cursor-pointer">
              <feather-icon icon="DownloadIcon" />
            </b-badge>
            <b-tooltip
            v-if="title == 'Receipt' && props.row.approved1 == 'Approved' && props.row.transactiontype!=='Other'"
            :id="'download' + props.row.id" :target="'download' + props.row.id" triggers="hover" >
              Download
            </b-tooltip>
            <b-badge
              v-if="userRole == 'admin' && (title == 'Employee' || title == 'Channel Partner' || title == 'Franchise')"
              variant="info" :id="'user' + props.row.id" class="mr-50 cursor-pointer" @click="handleUserLogin(props.row)">
              <feather-icon icon="UserIcon" />
            </b-badge>
            <b-tooltip
            v-if="userRole == 'admin' && (title == 'Employee' || title == 'Channel Partner' || title == 'Franchise')"
            :target="'user' + props.row.id" triggers="hover">
              Log in as {{ props.row.name }}
            </b-tooltip>
            <b-badge
              v-if="(edit == 1 || userRole == 'admin') && title !== 'Issue Log' && (title != 'Task' || (userRole == 'admin' || (props.row.enterby_data[0].id == userData.id)))"
              variant="warning" :id="'edit' + props.row.id" class="mr-50 cursor-pointer" @click="handleEdit(props.row)">
              <feather-icon icon="Edit2Icon" />
            </b-badge>
            <b-tooltip

            v-if="(edit == 1 || userRole == 'admin') && title !== 'Issue Log' && (title != 'Task' || (userRole == 'admin' || (props.row.enterby_data[0].id == userData.id)))"
            :target="'edit' + props.row.id" triggers="hover">
              Edit
            </b-tooltip>
            {{ canView }}
            <b-badge v-if="title !== 'Issue Log'" variant="warning"
              :id="'view' + props.row.id" class="mr-50 cursor-pointer" @click="handleView(props.row)">
              <feather-icon icon="EyeIcon" />
            </b-badge>
            <b-tooltip
            v-if="title !== 'Issue Log'"
            :target="'view' + props.row.id" triggers="hover">
              View
            </b-tooltip>


            <b-badge variant="success" :id="'password' + props.row.id" v-if="showPassword" class="mr-50 cursor-pointer"
              @click="handlePassword(props.row)">
              <feather-icon icon="LockIcon" />
            </b-badge>
            <b-tooltip v-if="showPassword" :target="'password' + props.row.id" triggers="hover">
              Change password
            </b-tooltip>
            <!-- <b-badge v-if="(edit == 1 || userRole == 'admin') &&
              plot &&
              (props.row.remaining_amount == '0.00' && title == 'Plot')
              " variant="info" :id="'salesdeed' + props.row.id" class="mr-50 cursor-pointer"
              @click="salesDeedClicked(props.row)">
              <feather-icon icon="TrelloIcon" />
            </b-badge> -->
            <!-- <b-tooltip :target="'salesdeed' + props.row.id" triggers="hover">
              Sales Deed
            </b-tooltip> -->
            <b-badge
              v-if="(canDelete == 1 || userRole == 'admin') && title != 'Issue Log' && (title != 'Task' || (userRole == 'admin' || (props.row.enterby_data[0].id == userData.id)))"
              variant="danger" :id="'delete' + props.row.id" class="cursor-pointer" @click="handleDelete(props.row)">
              <feather-icon icon="TrashIcon" />
            </b-badge>
            <b-badge v-if="(userRole == 'admin') && title == 'KYC'" variant="success" :id="'remarks' + props.row.id"
              class="ml-50 cursor-pointer" @click="handleRemarks(props.row.id)">
              <feather-icon icon="PlusIcon" />
            </b-badge>
            <b-tooltip
            v-if="(userRole == 'admin') && title == 'KYC'" variant="success" :id="'remarks' + props.row.id"
            :target="'remarks' + props.row.id" triggers="hover">
              Remarks
            </b-tooltip>
            <b-tooltip
            v-if="(canDelete == 1 || userRole == 'admin') && title != 'Issue Log' && (title != 'Task' || (userRole == 'admin' || (props.row.enterby_data[0].id == userData.id)))"

            :target="'delete' + props.row.id" triggers="hover">
              Delete
            </b-tooltip>

            <!-- <b-dropdown
                variant="link"
                toggle-class="text-decoration-none p-0"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="title == 'Receipt'"
                  @click="handelRecieptPDF(props.row)"
                >
                  <feather-icon icon="DownloadIcon" class="mr-50" />
                  <span>Download</span>
                </b-dropdown-item>
                <b-dropdown-item @click="handleEdit(props.row)">
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="handleDelete(props.row)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="showPassword"
                  @click="handlePassword(props.row)"
                >
                  <feather-icon icon="Edit3Icon" class="mr-50" />
                  <span>Change Password</span>
                </b-dropdown-item>
              </b-dropdown> -->
          </span>

          <!-- Column: Common -->
          <span v-else-if="props.column.type=='staticdropdown' || props.column.type == 'dropdown'">
            <div v-if="Array.isArray(props.row[props.column.field]) && props.row[props.column.field].length>0 ">
            {{props.row[props.column.field][0][props.column.responseValue]}}
            </div>
            <div v-else-if="typeof props.row[props.column.field] == 'string'">
              {{props.row[props.column.field]}}
            </div>
            <div v-else-if="props.row[props.column.field]">
              {{props.row[props.column.field][props.column.responseValue]}}
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <b-form-select v-model="pageLength" :options="['5', '10', '20', '50', '100', '500','1000','5000','10000']" class="mx-1"
                @input="changePagination()" />
              <span class="text-nowrap"> Showing {{ paginationStart }} to {{ paginationEnd }} of {{ paginationTotal
              }}</span>
            </div>
            <div>
              <b-pagination v-model="paginationValue" :total-rows="paginationTotal" :per-page="pageLength" first-number
                last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="changePagination('change')">
                <!-- @input="(value) => props.pageChanged({ currentPage: value })" -->
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <div id="element-to-convert" style="display: none">
        <div class="card">
          <div class="card-body mx-4">
            <div class="container">
              <table></table>
            </div>
          </div>
        </div>
      </div>
      <vue-html2pdf v-if="receiptData" :show-layout="false" :float-layout="true" :enable-download="true"
        :preview-modal="false" :paginate-elements-by-height="1400" filename="Receipt" :html2canvas="{}" :jsPDF="{
          format: 'a5',
        }" :pdf-quality="3" :manual-pagination="false" pdf-format="a5" :pdf-margin="0" pdf-orientation="landscape"
        pdf-content-width="1800px" @progress="onProgress($event)" ref="html2Pdf">
          <section slot="pdf-content">
        <!-- Include your common header component with the pageNumber prop -->
           <print-comp :receiptData="receiptData" />
          </section>
        </vue-html2pdf>

      <!-- <b-modal id="modal-form" v-model="showReceiptsModal" cancel-variant="outline-secondary" ok-title="Submit"
        cancel-title="Close" title="Receipts Download" hide-footer>
        <table class="table table-bordered">
          <thead class="text">
            <tr>
              <th>Plot No.</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="item.amount !== '0.00'" v-for="(item, index) in receipts" :key="index">
              <td>{{ item.plot_data[0].plotname }}</td>
              <td>
                <b-badge :id="'download' + index" @click="handelRecieptPDF(item.id)" variant="success"
                  class="mr-50 cursor-pointer">
                  <feather-icon icon="DownloadIcon" />
                </b-badge>
              </td>
            </tr>
          </tbody>
        </table>
      </b-modal> -->
      <b-modal id="modal-form" v-model="remarksPopUp" cancel-variant="outline-secondary" ok-title="Submit"
        cancel-title="Close" title="Remarks" hide-footer>
        <b-form-textarea v-model="remarksForUpdate" placeholder="Enter Remarks" rows="5" />
        <b-button variant="primary" @click.prevent="submitRemarksKyc($event)" class="mt-2">
          Submit
        </b-button>

      </b-modal>
      <!-- <div  class="d-none">
      <print-comp/>
    </div> -->
      <!-- <template #code>
      {{ codeColumnSearch }}
    </template> -->
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import printComp from "../views/print/printReceipt.vue";
import approvalStatic from "../views/setup/approval/ApprovalStatic.vue";
import reminderStatic from "../views/setup/reminder/ReminderStatic.vue";
import addTemplate from "../views/setup/template/AddTemplate.vue";
import TransferLead from "../views/crm/lead/TransferLead.vue";
import AddRequest from "@/views/hr/hrrequest/AddRequest.vue";
import receiptShow from '../views/accounting/receipt/Show.vue'
// import axios from '@/components/axios';
import vSelect from "vue-select";
import VueHtml2pdf from "vue-html2pdf";
import moment from 'moment';
import jsPDF from "jspdf";
import Form from "@/components/form/Form.vue";
import axios from '@/components/axios'
import viewPage from "@/components/viewPage.vue"
import salesshow from '../views/crm/sales/show.vue'
import siteshow from '../views/crm/sitevisit/Show.vue'
import landshow from '../views/crm/landsales/Show.vue'
import OtherPurchaseShow from '../views/accounting/otherpurchase/Show'
import LeadShow from "../views/crm/lead/Show.vue"
import PlotShow from "../views/master/crm/plot/Show.vue"
import LandPurchase from '../views/accounting/landpurchase/Show.vue'
import LandShowView from '../views/master/crm/land/Show.vue'
import ProjectShow from '../views/master/crm/project/Show.vue'

import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormSelect,
  BDropdown,
  BCol,
  BRow,
  BButton,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BTooltip,
  BSpinner,
  BFormTextarea,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import html2pdf from "html2pdf.js";
import salesDeed from "./salesDeed";
import * as XLSX from "xlsx";

// import { codeColumnSearch } from "./code";

export default {
  props: [
    "newPage",
    "moduleapi",
    "title",
    "addTourPath",
    "columns",
    "routerpath",
    "formOptions",
    "assignToFormOptions",
    "paging",
    "addPlot",
    "multiplepath",
    "approval",
    "reminder",
    "template",
    "lead",
    "add",
    "edit",
    "canDelete",
    "canView",
    "kyc",
    "bulksales",
    'viewFields',
    'popUpCompnent',
    'sheetApi',
    'viewComponent'
  ],
  components: {
    AddRequest,
    viewPage,
    salesshow,
    siteshow,
    LeadShow,
    addTemplate,
    TransferLead,
    reminderStatic,
    landshow,
    LandShowView,
    OtherPurchaseShow,
    approvalStatic,
    BFormTextarea,
    LandPurchase,
    BCardCode,
    BCol,
    BRow,
    html2pdf,
    vSelect,
    BFormFile,
    salesDeed,
    approvalStatic,
    VueGoodTable,
    BSpinner,
    VueHtml2pdf,
    BFormCheckboxGroup,
    printComp,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    PlotShow,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    Form,
    BTooltip,
    receiptShow,
    ProjectShow
  },
  data(props) {
    return {
      props,
      moment,
      imagePath: process.env.VUE_APP_IMAGE_PATH,

      data: [],
      remarksForUpdate: '',
      tableKey: 0,
      paginationValue: 1,
      paginationTotal: 0,
      loadData: false,
      visible: false,
      passwordVisible: false,
      tour: false,
      plot: false,
      plotData: "",
      PassWordField: {
        inputFields: [],
      },
      pageLength: 50,
      columnFilter: [],
      dir: false,
      showPassword: false,
      CPEditRights: false,
      CPDeleteRights: false,
      receiptData: "",
      paginationStart: 0,
      paginationEnd: 0,
      FranchiseEditRights: false,
      CityOption: [],
      FranchiseDeleteRights: false,
      EditField: {
        inputFields: [],
      },
      pagination: {
        enabled: true,
        mode: 'records',
        perPage: 100000,
        position: 'bottom',
        perPageDropdown: [3, 7, 9],
        dropdownAllowAll: false,
        setCurrentPage: 2,
        jumpFirstOrLast: true,
        firstLabel: 'First Page',
        lastLabel: 'Last Page',
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        infoFn: (params) => `my own page ${params.firstRecordOnPage}`,
      },
      multidelete: false,
      selectedID: 0,
      rowSelection1: [],
      rowSelection: [],
      renderComponent: false,
      baseApi: process.env.VUE_APP_APIENDPOINT,
      webEndpoint: process.env.VUE_APP_WEBENDPOINT,

      accessToken: localStorage.getItem("accessToken"), // JSON.parse()
      users: [],
      rows: [],
      columnsData: [],
      searchTerm: null,
      EDrights: false,
      isFilterSwitch: false,
      approvalPopUp: false,
      reminderPopUp: false,
      templatePopUp: false,
      salesdeedPopup: false,
      stateOptions: [],
      transferClick: false,
      userRole: "",
      enabledisable: [],
      columnsItem: "",
      projectOptions: [],
      showReceiptsModal: false,
      receipts: [],
      changeStatus: false,
      changeStatus: {},
      selectedPlot: {},
      searchData: {},
      viewPopUp: false,
      remarksPopUp: false,
      KycUserId: '',
      params:'',
      staticPopUp: false,
      leadSheetImport: null,
      oldStatus: '',
      newStatus: '',
      plotId:''


    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Active: "light-success",
        Inactive: "light-danger",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Pending: "secondary",
        Approved: "light-success",
        Applied: "light-info",
        Sold: "yellow",
        Booked: "info",
        Vacant: "success",
        Hold: "warning",
        "Pre Launching": "success",
        Launching: "info",
        Registered: 'danger',
        Running: "primary",
        "Sold Out": "danger",
        MQL: "light-success",
        "In Progress": "light-primary",
        "Not Interested": "light-danger",
        "Site Visit": "light-warning",
        "Schedule Zoom Demo": "light-info",
        Presentation: "light-success",
        Lost: "light-warning",
        Close: "light-danger",
        Accepted: "light-success",
        Complete: 'success',
        Open: 'info',
        pending: 'danger'
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  async mounted() {
    this.userData = JSON.parse(localStorage.getItem("userData"));
    this.userRole = this.userData.role;
    this.params = ''
    Object.keys(this.$route.query).map((item)=>{
      this.params+=`&${item}=${this.$route.query[item]}`
    })
    if (this.addTourPath) {
      this.tour = true;
    }
    if (this.addPlot) {
      this.plot = true;
    }
    this.columnsItem = this.columns;
    this.columnsItem.map((item) => {
      const data = {
        text: item.label,
        value: item,
      };
      this.columnsData.push(data);
    });
    this.columnFilter = this.columnsItem;
    // this.columnsItem.map((item) => {
    //   if (
    //     (item.field !== "enterby" || item.label == "Assign By") &&
    //     item.field !== "created_date" &&
    //     item.field !== "modifiedby" &&
    //     item.field !== "updated_date" &&
    //     item.field !== "enterdatetime" &&
    //     item.field !== "modifieddatetime"
    //   ) {
    //     this.columnFilter.push(item);
    //   }
    // });
    this.columnsItem = this.columnFilter;
    // this.rights()
    this.forceRerender();
    this.EditField.inputFields = this.formOptions.inputFields;
    this.passwordFieldHandel();
    this.formOptions.inputFields.map((item) => {
      if (item.type == "password"){
        this.showPassword = true;
      }
    });
    this.getusers();
    // this.getGridData();
    this.getState();
    if (this.title == "Plot") {
      this.getProject();
    }
  },
  created() {
    // this.$http.get("/good-table/basic").then((res) => {
    //   this.rows = res.data;
    // });
  },
  methods: {
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== '') {
        let test = image.includes(this.imagePath) ? image : this.imagePath + image
        return test
      }
      return image
    },
    async submitRemarksKyc() {
      if (this.title == 'Plot') {
        this.submitRemarks()
        return
      }
      await axios({
        method: "PUT",
        url: `${this.baseApi}/auth/userupdate/${this.KycUserId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify({ specialremarks: this.remarksForUpdate }),
      })
        .then((json) => {
          this.$swal({
            title: "Submited",
            text: json.data.message
              ? `${json.data.message}`
              : json.data.success
                ? `${json.data.success}`
                : "Update SuccessFully",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Error!",
            text: `${error}`,
            icon: "error",
            timer: 5000,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .finally(() => {
          this.remarksPopUp = false
          this.remarksForUpdate = ''
        })
    },
    handleRemarks(id) {
      this.remarksPopUp = !this.remarksPopUp
      this.KycUserId = id

    },
    handleCustomFilter(e, column, type,searchField) {
      if (type == 'textbox') {
        this.searchData[searchField?searchField:column] = e
        if (!e) {
          delete this.searchData[searchField?searchField:column]
        }

      }
      else {
        let arr = []
        e.map((item) => {
          arr.push(item.id)
        })
        this.searchData[searchField?searchField:column] = arr.join(',')
        if (e.length == 0) {
          delete this.searchData[searchField?searchField:column]
        }
      }
      let str = this.params
      for (let key in this.searchData) {
        str += '&' + key + '=' + this.searchData[key]
      }
      this.debounceInput(str)
    },
    debounceInput: _.debounce(function (str) {
      this.getGridData(str)
    }, 1000),
    async handleUserLogin(user) {
      await axios({
        method: "POST",
        url: `${this.baseApi}/userLoginById/${user.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      }).then((json) => {
        localStorage.setItem('accessToken', json.data.token)
        localStorage.setItem('userData', JSON.stringify(json.data.user))
        localStorage.setItem('refreshToken', json.data.token)

        this.$router.push('/').then(() => {
          window.location.reload()
        })
      })
    },
    handleMultiMessage() {
      // this.multidelete=true
      this.rowSelection = []
      this.rowSelection1.map((item) => {
        this.rowSelection.push(item.mobile)
      })
    },
    clickStatusChage(row, title) {
      if (title == 'Plot') {
        this.changeStatus[row.id] = true
        this.oldStatus = row.status
        this.plotId = row.id
      }
      this.$forceUpdate()
    },
    async handleStatusChage(status, id) {
      this.newStatus = status
      if (this.oldStatus && (this.oldStatus.toLowerCase() == 'booked' || this.oldStatus.toLowerCase() == 'sold' || this.oldStatus.toLowerCase() == 'registered')) {
        if (status.toLowerCase() == 'vacant' || status.toLowerCase() == 'hold') {
          this.$swal({
            title: "Are you sure?",
            text: `This plot is already ${this.oldStatus} do you want to change status to ${status}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, update it!",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          })
            .then((result) => {
              if (result.value) {
                this.handleStatus()
              }
            })
        }
        else {
          this.handleStatus()
        }
      }
      else {
        this.handleStatus()
      }

    },
    async submitRemarks() {
      await axios({
        method: "POST",
        url: `${this.baseApi}/plot/change-status`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify({
          id: this.plotId,
          status: this.newStatus,
          remarks: this.remarksForUpdate,
        }),
      }).then((json) => {
        this.remarksPopUp = false
        this.remarksForUpdate = ''
        this.changeStatus[this.plotId] = false
         this.getGridData()
        this.$forceUpdate()
      })
    },
    async handleStatus() {
      this.remarksPopUp = true
    },
    handleClickBulkSales() {
      this.$router.push('/crm/multisales/addsales')
    },
    handleMultiDelete() {
      let ids = [];
      this.rowSelection.map((item) => {
        ids.push(item.id)
      })
      if (ids.length == 0) {
        this.$swal({
          icon: "warning",
          title: "Warning",
          text: "Please select atleast one",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then(async(result) => {
          if (result.value) {
            await axios({
              method: "delete",
              url: `${this.moduleapi}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              data: JSON.stringify({
                ids,
              }),
            })
            .then((json) => {
              // this.$router.push(this.options.submitRouterPath);
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your data has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getGridData(this.params);
            });
          }
        })
        .catch((error) => console.log(error, "error"))
        .finally(() => {
          this.multidelete = false;
        })
    },
    selectionChanged(params) {
      // this.multidelete = true;
      this.rowSelection = params.selectedRows;
      // if (params.selectedRows.length == 0) {
      //   this.multidelete = false;
      // }
      // console.log(params.selectedRows.length)
    },
    async downloadExcel(e) {
      if (e == 'All') {
         await axios({
              method: "GET",
              url: `${this.baseApi}/${sheetApi}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
         })
           .then((res) => {
              let fileURL = process.env.VUE_APP_IMAGE_PATH + res?.data['export-url']?.url.split('/ng-erp/')[1]
              const fURL = document.createElement("a");
              fURL.href = fileURL;
              fURL.setAttribute("download", `Lead.xlsx`);
              document.body.appendChild(fURL);
              document.body.appendChild(fURL);
              fURL.click();
            })
      }
      else {
        let data = []
        this.rows.map((item, index) => {
          data[index] = {}
          this.columnsItem.map((inner) => {
            if (inner.type == 'dropdown' || inner.type == 'staticdropdown') {
              if (Array.isArray(item[inner.field])) {
                data[index][inner.label] = item[inner.field].length > 0 ? item[inner.field][0][inner.responseValue] : ''
              }
              else if(item[inner.field]){
                data[index][inner.label] = item[inner.field][inner.responseValue]
              }
              else {
                data[index][inner.label]=''
              }
            }
            else if (inner.field !== 'action') {
              data[index][inner.label] = item[inner.field]
            }
          })
        })
        const data11 = XLSX.utils.json_to_sheet(data, this.columnsItem);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data11, "data");
        XLSX.writeFile(wb, `${this.title}.xlsx`);
      }
    },
    async approveReceipt(row, status, title) {
      if (title == "KYC") {
        this.handleKYC(row, status);
        return;
      }

      this.$swal({
        title: `Are you sure to ${status == "Approved" ? "Approve" : "Reject"
          }?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `${status == "Approved" ? "Approve" : "Reject"}`,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then(async (result) => {
          const data = {
            approved1: status,
          };
          if (status == 'Approved') {
            data.approved1datetime = moment(new Date()).format()
          }
          if (result.value) {
            await axios({
              method: "put",
              url: `${this.baseApi}/receipt/${row.id}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              data: JSON.stringify(data),
            })
              .then((json) => {
                if (json.data.status == 200 || json.data) {
                  this.$swal({
                    icon: "success",
                    title: `${status == "Approved" ? "Approved" : "Rejected"}`,
                    text: `Your data has been ${status == "Approved" ? "Approved" : "Rejected"
                      }.`,
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  });
                  this.getGridData(this.params);
                }
              })
              .catch((error) =>
                this.$swal({
                  title: "Error!",
                  text: `${error}`,
                  icon: "error",
                  timer: 5000,
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                })
              );
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async handleKYC(row, status) {
      this.$swal({
        title: `Are you sure to ${status == "Approved" ? "Approve" : "Reject"
          }?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `${status == "Approved" ? "Approve" : "Reject"}`,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          let url =
            row.role == "channelpartner"
              ? `${this.baseApi}/channelpartner/${row.id}`
              : `${this.baseApi}/franchise/${row.id}`;
          let data = {
            is_kyc: status == "Approved" ? 1 : 2,
          };

          await axios({
            method: "put",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((json) => {
              if (json.data.status == 200 || json.data) {
                this.$swal({
                  icon: "success",
                  title: `${status == "Approved" ? "Approved" : "Rejected"}`,
                  text: `Your data has been ${status == "Approved" ? "Approved" : "Rejected"
                    }.`,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.getGridData(this.params);
              }
            })
            .catch((error) =>
              this.$swal({
                title: "Error!",
                text: `${error}`,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              })
            );
        }
      });
    },
    salesDeedClicked(row) {
      this.selectedID = row.id;
      this.salesdeedPopup = true;
      this.selectedPlot = row
    },
    async handelClickEnableDisable(id) {
      const data = {
        id: id,
        active: this.enabledisable[id] == true ? 1 : 0,
      };

      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/project/change-active`,
        data: JSON.stringify(data),
      };
      await axios(reportauthority)
        .then((response) => {
          this.$swal({
            title: "Submited",
            text: `${this.enabledisable[id]
              ? "Project Enable Successfully"
              : "Project Disable Successfully"
              }`,
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => console.log(error, "error"));
    },
    async getState() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getState`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.stateOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },

    async getProject() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/project`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.projectOptions = response.data.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    advanceGlobleSearch(val) {
      this.searchTerm = val;
    },
    clearFilter() {
      this.searchTerm = null;
    },
    async advanceSearch(val, DropDown) {
      this.searchTerm = val;
      if (DropDown == "project") {
        this.searchTerm = val.name;
      }
      if (DropDown == "state") {
        const reportauthority = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/getCityByState`,
          data: {
            State: val,
          },
        };
        await axios(reportauthority)
          .then((response) => {
            this.CityOption = response.data.data;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    searchFieldWise(field, value) {

    },
    closepopup() {
      this.staticPopUp = false;
      this.transferClick = false;
      this.salesdeedPopup = false;
      this.viewPopUp = false;

      this.selectedID = null;
      this.remarksForUpdate =null;
      this.getGridData(this.params)
    },
    handleClickApproval() {
      this.selectedID = 0;
      this.approvalPopUp = true;
    },
    handleClickReminder() {
      this.selectedID = 0;
      if (this.reminder == true) {
        this.reminderPopUp = true;
      } else if (this.template == true) {
        this.templatePopUp = true;
      }
    },
    isFilterColumn() {
      this.columnsItem = [];
      const data = this.columnFilter;
      this.columnFilter = [];
      data.map((item) => {
        if (item.field !== "action") {
          this.columnFilter.push(item);
        }
      });
      data.map((item) => {
        if (item.field == "action") {
          this.columnFilter.push(item);
        }
      });
      this.columnsItem = this.columnFilter;
    },
    // printData() {
    //   // const divToPrint = document.getElementById('printTable')
    //   const newWin = window.open()
    //   newWin.document.write(`${this.rows}`)
    //   newWin.print()
    //   newWin.close()
    // },
    // async rights() {
    //   const userId = JSON.parse(localStorage.getItem('userData'))
    //   const accessToken = localStorage.getItem('accessToken')
    //   const baseApi = process.env.VUE_APP_APIENDPOINT
    //   const data = {
    //     id: userId.id,
    //     type: 'User'
    //   }
    //   const requestOptionsUsers = {
    //     method: 'post',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${accessToken}`
    //     },
    //     url: `${baseApi}/getuserrights`,
    //     data
    //   }

    //   await axios(requestOptionsUsers)
    //     .then((response) => {
    //       this.rightsdata = response.data.data
    //       if (this.routerpath == '/master/crm/addchannelpartner' || this.routerpath == '/master/crm/franchise/addfranchise') {
    //         if (this.routerpath == '/master/crm/addchannelpartner') {
    //           if (this.rightsdata[607].edit == 1) {
    //             this.CPEditRights = true
    //           } else {
    //             this.CPEditRights = false
    //           }
    //           if (this.rightsdata[607].delete == 1) {
    //             this.CPDeleteRights = true
    //           } else {
    //             this.CPDeleteRights = false
    //           }
    //         }

    //         if (this.routerpath == '/master/crm/franchise/addfranchise') {
    //           if (this.rightsdata[608].edit == 1) {
    //             this.FranchiseEditRights = true
    //           } else {
    //             this.FranchiseEditRights = false
    //           }
    //           if (this.rightsdata[608].delete == 1) {
    //             this.FranchiseDeleteRights = true
    //           } else {
    //             this.FranchiseDeleteRights = false
    //           }
    //         }
    //       } else {
    //         this.FranchiseEditRights = true
    //         this.FranchiseDeleteRights = true
    //         this.CPEditRights = true
    //         this.CPDeleteRights = true
    //       }
    //     })
    // },
    async getusers() {
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const requestOptionsUsers = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        url: `${baseApi}/getUsers`,
      };

      await axios(requestOptionsUsers).then(async (response) => {
        this.users = response.data.data;
        // this.data['getUsers'] = response.data.data
        await this.getGridData(this.params)
        this.getAllDropdown()
      });
    },
    setDropdownValue() {
      //   console.log(this.props._props.formOptions.inputFields, 'test--')
      //   if (this.props.columns) {
      //   }
    },
    passwordFieldHandel() {
      this.formOptions.inputFields.map((item) => {
        // console.log(item.type, "item---");
        if (item.type == "password") {
          this.PassWordField.inputFields.push(item);
        }
      });

      // console.log(this.formOptions.inputFields, "item--");
      // PassWordField.push(formOptions.)
    },
    handleCloseModel() {
      // console.log("first");
      this.visible = false;
    },
    // handleClosePasswordModel() {
    //   this.passwordVisible = false;
    // },
    handleClickAddTour() {
      this.$router.push(`${this.addTourPath}`);
    },
    handleClickAddMultiple() {
      this.$router.push(`${this.multiplepath}`);
    },
    handleClickPlot() {
      document.getElementById("fileUpload").click();
    },
    handleClickLead() {
      document.getElementById("fileUploadLead").click();
    },
    async handleFileChange(e) {
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("csv", e);
      formData.append("type", "testing");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/plotAttachment`,
      };

      await axios(requestOptions)
        .then((json) => {
          this.$swal({
            title: "Submited",
            text: json.data.message
              ? `${json.data.message}`
              : json.data.success
                ? `${json.data.success}`
                : "Update SuccessFully",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          this.getGridData()
        })
        .catch((error) =>{
           this.$swal({
            title: "Error !",
            text: "Something went wrong , Please check your file",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

        });
    },
    async handleFileChangeLead(e) {
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("csv", e);
      formData.append("type", "testing");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/bulklead`,
      };

      await axios(requestOptions)
        .then((json) => {
          let msg = 'Imported Successfully'
          // this.leadSheetImport = null
          let emails=''
          if (json.data.existing_emails) {
            emails= [...new Set(json.data.existing_emails)]
          }
          msg += emails.length>0?' <br/><b>existing emails: </b><br/>'+ emails.join(','):''
          this.$swal({
            title: "Submited",
            html: msg,
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          // window.location.reload()

        })
        .catch((error) => {
          this.$swal({
            title: "Error !",
            text: "Some error occurred",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          console.log(error, "error");
        })
        .finally(() => {
        })
    },
    handleClickTransferLead() {
      this.transferClick = true;
    },
    onProgress(event) {
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    // async generatePDF() {
    //   // console.log(this.$route.params.id, "id====");
    //   await axios({
    //     method: "GET",
    //     url: `${this.baseApi}/getPlotById/${this.receiptData.plotno}`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${this.accessToken}`,
    //     },
    //   })
    //     .then((json) => {
    //       this.receiptData = {
    //         ...this.receiptData,
    //         ...{ plotName: json.data.data[0].plotno },
    //       };
    //     })
    //     .catch((error) => console.log(error, "error"));
    //   // this.$refs.html2Pdf.generatePdf();
    // },
    handelShowModal(receipt) {
      this.showReceiptsModal = true;
      this.receipts = receipt.receipt_items;
    },
    async handelRecieptPDF(id) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getreceiptById/${id}`,
      };

      await axios(requestOptions)
        .then((json) => {
          this.receiptData = json.data.data[0];
          let year = moment(this.receiptData.created_date).year()
          let id = this.receiptData.id.toString().padStart(5,'0')
          this.receiptData.receiptNo = 'NGR-' + year + '-' + id

          if (this.receiptData && this.receiptData.receipt_items.length > 30) {
            this.$swal({
              title: "Denied",
              text: "Cannot generate receipt which contains more than 30 plot payments",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          } else {
            this.receiptData.paymentDetails =''
            if ((parseFloat(this.receiptData?.receipt_items[0]?.remaining) + parseFloat(this.receiptData?.receipt_items[0]?.amount)) == parseFloat(this.receiptData.receipt_items[0].sales_data[0].totalpayment))
            {
              this.receiptData.paymenttype= this.receiptData?.receipt_items[0].sales_data[0].paymenttype
            }
            else if (this.receiptData?.receipt_items[0].sales_data[0].bookingtype == 'EMI') {
              this.receiptData.paymenttype = 'EMI'
            }
            else {
              this.receiptData.paymenttype = 'Part Payment'
            }
            this.$refs.html2Pdf.generatePdf();
          }



          // this.generatePDF();
          //   var doc = new jsPDF('p', 'pt', 'A4');
          //  margins = {
          //     top: 80,
          //     bottom: 60,
          //     left: 40,
          //     width: 522
          // };

          // doc.fromHTML(this.$refs.testHtml, margins.left, margins.top,{
          //   'width' : margins.width
          // });

          // doc.save('test.pdf');

          // let url = process.env.VUE_APP_IMAGE_PATH + json.data.data.path
          // const ex = "pdf";

          // axios({
          //   url,
          //   method: "GET",
          //   responseType: "blob",
          // }).then((response) => {
          //   const fileURL = window.URL.createObjectURL(
          //     new Blob([response.data])
          //   );
          //   const fURL = document.createElement("a");

          //   fURL.href = fileURL;
          //   fURL.setAttribute("download", `Receipt.${ex}`);
          //   document.body.appendChild(fURL);

          //   fURL.click();
          // });
        })
        .catch((error) => console.log(error, "error"));
    },
    handleClickAddbutton() {
      if (JSON.stringify(this.formOptions.inputfiels) == "[]") {
        this.formOptions.inputFields = this.editData;
      } else {
        this.formOptions.inputFields = this.EditField.inputFields;
      }

      // this.$eventBus.$emit("onMounted", this.formOptions);
      if (this.newPage == true) {
        this.$router.push(`${this.routerpath}`);
      }
      if (!this.newPage) {
        let countFields = 0;
        this.formOptions.inputFields &&
          this.formOptions.inputFields.map((item) => {
            if (item.type != "hidden") {
              countFields = countFields + 1;
            }
          });
        if (countFields < 10 || this.popUpCompnent ) {
          if(this.popUpCompnent){
            this.staticPopUp =true
          }else{
            this.visible = true;
          }
        } else {
          this.$router.push(`${this.routerpath}`);
        }
      }

      if (this.add !== 1 && this.userRole !== "admin") {
        this.visible = false;
      }
      this.forceRerender();
      this.selectedID = 0;
    },
    changePagination() {
       let str = this.params
      for (let key in this.searchData) {
        str += '&' + key + '=' + this.searchData[key]
      }
      console.log(this.searchData);
      this.getGridData(str);
    },
    getGridData(params) {
      this.loadData = true;
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      };
      fetch(
        `${this.moduleapi}?${this.paging ? this.paging : `pagenum=${this.paginationValue}&pagesize=${this.pageLength}` + (params ? params : '')
        }`,
        // fetch(
        //   `${this.moduleapi}?pagenum=1&pagesize=10`,
        requestOptions
      )
        .then((res) => res.json())
        .then((json) => {
          this.paginationTotal = json.data.total
          this.paginationStart = json.data.from
          this.paginationEnd = json.data.to
          if (json.data) {
            this.rows = [];
            this.rows = json.data;
          }
          if (json.data.data) {
            this.rows = [];
            this.rows = json.data.data;
          }
          this.enabledisable = {};
          this.rows.map((item) => {
            if (item.active == 1) {
              this.enabledisable[item.id] = true;
            } else {
              this.enabledisable[item.id] = false;
            }
          });
          if (json.data?.first_page_url?.includes("commission")) {
            this.rows = [];
            json.data.data.map((item) => {
              const commisionID = item.id;
              item.CommissionItem.map((data) => {
                data.id = commisionID;
                const data1 = { ...data, type: item.type };
                this.rows.push(data1);
              });
            });
            // this.rows = json.data.data[0].CommissionItem
            // this.commisionID = json.data.data
          }
          if (json.data?.first_page_url?.includes("target")) {
            this.rows = [];
            json.data.data.map((item) => {
              item.targetItem.map((data) => {
                data.enterby = item.enterby;
                data.modifiedby = item.modifiedby;
                const data1 = {
                  updated_date: item.updated_date,
                  created_date: item.created_date,
                  year: item.year,
                  ...data,
                };
                this.rows.push(data1);
              });
            });
          }
          if (this.title == "Customer" || this.title == "Lead" ) {
            this.rows.map((item) => {
              if (
                item.leadsource_name == "Employee" ||
                item.leadsource_name == "Channel Partner" ||
                item.leadsource_name == "Franchise" ||
                item.leadsource_name == "Self"
              ) {
                this.users.map((innerItem) => {
                  if (item.subsource == innerItem.id) {
                    item.subsource = innerItem.name;
                  }
                });
              }
            });
          }
          if (this.title == "Receipt") {
            this.rows.map((item) => {
              item.plots = []
              if (item.receipt_items.length>0) {
                  item.receipt_items.map((ritem) => {
                    item.plots.push(ritem.plot_data.length>0?ritem.plot_data[0].plotno:'')
                  })
              }
              item.plots = item.plots.join(', ')
            });
          }
          if (this.title == "Project") {
            this.rows.map((item) => {
              item.assigntoRole = ''
              if (item.assignto.length>0) {
                this.users.map((innerItem) => {
                  item.assignto.map((assignto) => {
                    if (assignto == innerItem.id) {
                        if (!item.assigntoRole.includes(innerItem.role.slice(1))) {
                            item.assigntoRole +=` ${innerItem.role.charAt(0).toUpperCase() + innerItem.role.slice(1)}`
                          }
                      }
                    })
                });
              }
            });
          }
          if (this.title == "Plot") {
            this.rows.map((item) =>
            {
              item.assigntoRole = ''
              if (item.project.assignto.length>0) {
                this.users.map((innerItem) => {
                  item.project.assignto.map((assignto) => {
                    if (assignto == innerItem.id) {
                        if (!item.assigntoRole.includes(innerItem.role.slice(1))) {
                            item.assigntoRole +=` ${innerItem.role.charAt(0).toUpperCase() + innerItem.role.slice(1)}`
                          }
                      }
                    })
                });
              }
            });
          }
          this.columnsItem.map(async (item) => {
            if (item.type == "staticdropdown") {
              this.rows.map((data) => {
                this.users.map((data1) => {
                  if (data[item.field] == data1.id) {
                    data[item.field] = data1;
                  }
                });
              });
            }
            if (item.toggle == true) {
              this.rows.map((data) => {
                if (data.active == 0) {
                  data.active = "False";
                }
                if (data.active == 1) {
                  data.active = "True";
                }
              });
            }
            if (item.type == "dropdown") {
              const accessToken = localStorage.getItem("accessToken");
              const baseApi = process.env.VUE_APP_APIENDPOINT;
              const requestOptionsUsers = {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
                },
                url: `${baseApi}/${item.url}`,
              };

              await axios(requestOptionsUsers)
              .then((response) => {
                this.loadData = true;
                  this.loadData=false
                response.data.data.data
                ? // ? (this.data[Array(item.url)] = response.data.data.data)
                (this.data[item.url] = response.data.data.data)
                : response.data.data
                ? (this.data[item.url] = response.data.data)
                : (this.data[item.url] = response.data);
                })
                .catch((error) => console.log(error, "error"));
                this.rows.map((data) => {
                  this.data[item.url] &&
                    this.data[item.url].map((data1, index) => {
                      if (data[item.field] == data1.id) {
                        if (data[item.field] == "srno") {
                          data[item.field] = index + 1;
                        }
                        data[item.field] = data1[item.responseValue];
                      }
                    });
                });
            }
          });
          this.loadData = false;
          this.data['getUsers'] = this.users
        }).catch((error) => {
          this.loadData = false;
        });
    },
    getAllDropdown() {
      // this.columnsDatatest.map(async (item) => {
      //   if (item.type == "staticdropdown") {
      //     this.rows.map((data) => {
      //       this.users.map((data1) => {
      //         if (data[item.field] == data1.id) {
      //           data[item.field] = data1.name;
      //         }
      //       });
      //     });
      //   }
      //   if (item.toggle == true) {
      //     this.rows.map((data) => {
      //       if (data.active == 0) {
      //         data.active = "False";
      //       }
      //       if (data.active == 1) {
      //         data.active = "True";
      //       }
      //     });
      //   }
      //   if (item.type == "dropdown") {
      //     const accessToken = localStorage.getItem("accessToken");
      //     const baseApi = process.env.VUE_APP_APIENDPOINT;
      //     const requestOptionsUsers = {
      //       method: "GET",
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${accessToken}`,
      //       },
      //       url: `${baseApi}/${item.url}`,
      //     };

      //     await axios(requestOptionsUsers)
      //       .then((response) => {
      //         response.data.data.data
      //           ? // ? (this.data[Array(item.url)] = response.data.data.data)
      //           (this.data[item.url] = response.data.data.data)
      //           : response.data.data
      //             ? (this.data[item.url] = response.data.data)
      //             : (this.data[item.url] = response.data);
      //       })
      //       .catch((error) => console.log(error, "error"));
      //     this.rows.map((data) => {
      //       this.data[item.url] &&
      //         this.data[item.url].map((data1, index) => {
      //           if (data[item.field] == data1.id) {
      //             if (data[item.field] == "srno") {
      //               data[item.field] = index + 1;
      //             }
      //             data[item.field] = data1[item.responseValue];
      //           }
      //         });
      //     });
      //   }
      // });
    },
    async handelMultiple(id) {
      await axios({
        method: "GET",
        url: `${this.baseApi}/gettargetById/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          const data = json.data.data[0];
          this.$router.push(
            data.targetItem
              ? `/crm/editmultipletarget/${data.id}`
              : `/crm/edittarget/${data.id}`
          );
        })
        .catch((error) => console.log(error, "error"));
    },
    handleView(row) {
      this.viewPopUp = true
      this.selectedID = row = row.row ? row.row.id : row.id;
    },
    handleEdit(row) {
      row = row.row ? row.row : row;
      if (this.title == "Site Visit" && row.action == 0) {
        this.$swal({
          title: "Cancelled",
          text: "This Site Visit has been cancelled",
          icon: "error",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      if (this.popUpCompnent) {
        this.staticPopUp = true;
        this.getSelectedId(row);
        return;
      }

      if (JSON.stringify(this.formOptions.inputfiels) == "[]") {
        this.formOptions.inputFields = this.editData;
      } else {
        this.formOptions.inputFields = this.EditField.inputFields;
      }
      let countFields = 0;
      this.formOptions.inputFields.map((item) => {
        if (item.type !== "hidden") {
          countFields = countFields + 1;
        }
      });
      const newPath = this.routerpath.replace("add", "edit");
      if (this.multiplepath == "/crm/addmultipletarget") {
        this.handelMultiple(row.id);
        return;
      }
      if (this.newPage == true) {
        this.$router.push(`${newPath}/${row.id}`);
      }
      if (!this.newPage) {
        countFields < 10
          ? (this.handleOpenModel(), this.getSelectedId(row))
          : this.$router.push(`${newPath}/${row.id}`);
      }
      this.forceRerender();
      if (this.edit !== 1 && this.userRole !== "admin") {
        this.visible = false;
      }
    },
    handlePassword(row) {
      this.PassWordField.inputFields = [];
      this.editData = this.formOptions.inputFields;
      this.formOptions.inputFields.map((item) => {
        if (item.type == "password") {
          this.PassWordField.inputFields.push(item);
          item.class = "col-md-12";
        }
      });
      this.formOptions.inputFields = [];
      this.formOptions.inputFields = this.PassWordField.inputFields;
      const newPath = this.routerpath.replace("add", "edit");
      this.handleOpenModel(), this.getSelectedId(row);
      // : this.$router.push(`${newPath}?id=${row.id}`);
      this.forceRerender();
    },
    handleDelete(row) {
      this.formOptions.inputFields = this.EditField.inputFields;
      const ids = [];
      ids.push(row.id);

      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            axios({
              method: "delete",
              url: `${this.moduleapi}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              data: JSON.stringify({
                ids,
              }),
            }).then((json) => {
              // this.$router.push(this.options.submitRouterPath);
              this.getGridData(this.params);
              this.$swal({
              icon: "success",
              title: "Deleted!",
              text: "Your data has been deleted.",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            });

          }
        })
        .catch((error) => console.log(error, "error"));
    },
    handleOpenModel() {
      this.visible = true;
    },
    // handleOpenPasswordModel() {
    //   this.passwordVisible = true;
    // },
    getSelectedId(row) {
      this.selectedID = row.id;
    },
    excelClick() {
      if (this.plot == true) {
          const fileURL = `${this.webEndpoint}/docs/plot.xls`;
          const fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", `Sample Plot.xls`);
          document.body.appendChild(fURL);

          fURL.click();
      } else if (this.lead == true) {
        const fileURL = `${this.webEndpoint}/docs/lead.xlsx`;
          const fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", `Sample lead.xlsx`);
          document.body.appendChild(fURL);

          fURL.click();
      }
    },
    async forceRerender() {
      // Remove MyComponent from the DOM
      this.renderComponent = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;
    },
  },
};
</script>
